import React, { PropsWithChildren } from 'react'
import './index.scss'
import { Link } from 'react-router'
import clsx from 'clsx'

interface ButtonProps {
    mainColor: boolean
    type: 'primary' | 'primary-small' | 'secondary' | 'secondary-small' | 'tertiary'
    disabled?: boolean
    className?: string

    onClick?(): void

    typeLink?: boolean
    linkTo?: string
    icon?: string
    iconAltText?: string
    isPlainButton?: boolean
    onlyIcon?: boolean
    submitType?: 'submit' | 'button'
    target?: string
    reverseIconPosition?: boolean
    title?: string

    linkOnClick?(): void
}

const Button = (props: PropsWithChildren<ButtonProps>) => {
    const {
        mainColor = true,
        disabled = false,
        className,
        onClick,
        type,
        children,
        icon,
        iconAltText,
        typeLink,
        linkTo,
        onlyIcon,
        reverseIconPosition = false,
        isPlainButton = false,
        linkOnClick,
        submitType = 'submit',
        target = '_self',
        title,
    } = props

    const classNames = clsx(
        mainColor ? 'main-color-set' : 'second-color-set',
        disabled && 'disabled',
        type,
        onlyIcon && 'only-icon'
    )

    return (
        <div className={clsx('button-component', className)} data-testid="button-component" title={title}>
            {!typeLink && !isPlainButton && (
                <button
                    className={classNames}
                    disabled={disabled}
                    type={submitType}
                    onClick={!disabled ? onClick : () => {}}
                >
                    {children}
                    {icon && (
                        <img
                            src={icon}
                            alt={iconAltText}
                            className={clsx(reverseIconPosition && 'reverse-icon-position')}
                        />
                    )}
                </button>
            )}
            {typeLink && (
                <Link to={linkTo ? linkTo : '#'} className={classNames} onClick={linkOnClick} target={target}>
                    {children}
                    {icon ? <img src={icon} alt={iconAltText} /> : null}
                </Link>
            )}
            {isPlainButton && (
                <a href={linkTo} className={classNames}>
                    {children}
                </a>
            )}
        </div>
    )
}

export default Button
